/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { storageNewApiHost } from '@/model/dataLayer/api/storage/inventoryUtils'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

const entity = {
  productName: {
    displayName: 'name'
  },
  priceLiteral: {
    displayName: 'price',
    type: IKDataEntity.Types.Float
  },
  unitDisplay: {
    displayName: 'unit'
  },
  operationType: {
    displayName: 'operation'
  },
  operatorType: {
    displayName: 'operator'
  },
  note: {}
}

const config = {
  load: async function (filter) {
    const [startTime, endTime] = filter[0].dateFilter
    const res = (await hillo.jsonPost(storageNewApiHost + 'change/list/' + await getCurrentDeviceId(), {
      dateTimeFrom: startTime + 'T00:00:00.000Z',
      dateTimeTo: endTime + 'T23:59:59.000Z'
    }))
    res.map(it => {
      it.productName = it.storageItem?.name
      return it
    })
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)
